export interface InsufficientCreditsPayload {
  shortfallCredits: number
  balanceCredits: number
  topupUrl?: string
}

type Listener = (payload: InsufficientCreditsPayload) => void

const listeners = new Set<Listener>()

/** Called by the api client on a 402 insufficient_credits response. React-free. */
export function emitInsufficientCredits(payload: InsufficientCreditsPayload): void {
  listeners.forEach((l) => l(payload))
}

/** Subscribe (e.g. the InsufficientCreditsModal provider). Returns an unsubscribe fn. */
export function subscribeInsufficientCredits(listener: Listener): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
